module.exports = __webpack_public_path__ + "img/1503007729.11c402ad.jpg";